import { css, styled } from "@/root/stitches.config";
import { Title } from "@/components/title";

import WhatsappIcon from "@/assets/icons/whatsapp.svg";

const contacts = [
    {
        id: 1,
        label: "Gung Darma (082339646684)",
        href: "https://wa.me/+6282339646684?text=hallo%20kak%20Gung%20Darma%2C%20saya%20ingin%20bertanya%20nih.%20",
        icon: WhatsappIcon,
    },
    {
        id: 2,
        label: "Dani (0881037552324)",
        href: "https://wa.me/+62881037552324?text=Hai%20kak%20Dani%2C%20saya%20ingin%20bertanya%20nih.%20",
        icon: WhatsappIcon,
    },
];

const SocialLink = styled("a", {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "1rem",
    color: "$white",
    fontFamily: "$main",
    letterSpacing: 2,
    textDecoration: "none",
    fontSize: "1vw",
    textDecorationColor: "transparent",
    "&:hover": {
        textDecoration: "underline",
        textDecorationColor: "$white",
    },
    "@mobile": {
        fontSize: "1rem",
    },
});

export default function FooterContacts() {
    return (
        <section
            className={css({
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gridColumn: "7 / 10",
                paddingTop: "9rem",
                gap: "1.5rem",
                zIndex: 2,
                "@tablet": {
                    gridColumn: "1 / 7",
                    paddingTop: "1.5rem",
                },
                "@mobile": {
                    gridColumn: "1 / -1",
                    paddingTop: "1.5rem",
                },
            }).toString()}
        >
            <Title
                order={2}
                css={{
                    fontSize: "1.25rem",
                    color: "$white",
                }}
            >
                Contact Us
            </Title>

            <div
                className={css({
                    display: "flex",
                    flexDirection: "column",
                    gap: "1.25rem",
                }).toString()}
            >
                {contacts.map((contact) => (
                    <SocialLink
                        key={contact.id}
                        href={contact.href}
                        target="_blank"
                    >
                        <img
                            src={contact.icon}
                            alt="WhatsApp"
                            style={{
                                width: "1.45rem",
                                height: "1.45rem",
                            }}
                        />

                        <span>{contact.label}</span>
                    </SocialLink>
                ))}
            </div>
        </section>
    );
}